var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"noticeItemWrap",attrs:{"to":{name:'detail',params:{id:_vm.NoticeItem.id}}}},[_c('p',{staticClass:"title"},[_vm._v(_vm._s(_vm.NoticeItem.title))]),_vm._v(" "),_c('p',{staticClass:"date"},[_vm._v(_vm._s(_vm._f("timeFormat")(_vm.NoticeItem.publish_at)))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-02243a22","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/noticeItem.vue
// module id = null
// module chunks = 